var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
export function embedSchematic(parentSchematic, embeddedSchematics) {
    return function (vars) {
        return new EmbedSchematicImplementation(vars, parentSchematic, embeddedSchematics);
    };
}
var EmbedSchematicImplementation = /** @class */ (function () {
    function EmbedSchematicImplementation(vars, parent, embeds) {
        this.vars = vars;
        this.parent = parent;
        this.embeds = embeds;
    }
    EmbedSchematicImplementation.prototype.chunk = function (input) {
        var e_1, _a, e_2, _b;
        var rootInput = __assign({}, input);
        var attrs = Object.keys(this.embeds);
        var inputs = {};
        if (attrs.length) {
            try {
                for (var attrs_1 = __values(attrs), attrs_1_1 = attrs_1.next(); !attrs_1_1.done; attrs_1_1 = attrs_1.next()) {
                    var attr = attrs_1_1.value;
                    inputs[attr] = rootInput[attr];
                    delete rootInput[attr];
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (attrs_1_1 && !attrs_1_1.done && (_a = attrs_1.return)) _a.call(attrs_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        var rootChunkedInput = this.parent(this.vars).chunk(rootInput);
        var rootSelection = rootChunkedInput.selection;
        var root = rootSelection.root;
        var rootChunk = rootChunkedInput.chunks.find(function (chunk) { return chunk.bucket === root.bucket && chunk.id === root.id; }).payload;
        if (rootChunk.type === 'rejection') {
            return rootChunkedInput;
        }
        var chunks = rootChunkedInput.chunks;
        var selection = {
            root: root,
            embed: __assign({}, rootSelection.embed),
        };
        try {
            for (var attrs_2 = __values(attrs), attrs_2_1 = attrs_2.next(); !attrs_2_1.done; attrs_2_1 = attrs_2.next()) {
                var attr = attrs_2_1.value;
                var input_1 = inputs[attr];
                if (input_1 !== undefined) {
                    var embed = this.embeds[attr](this.vars, rootChunk.data).chunk(input_1);
                    chunks.push.apply(chunks, __spread(embed.chunks));
                    selection.embed[attr] = embed.selection;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (attrs_2_1 && !attrs_2_1.done && (_b = attrs_2.return)) _b.call(attrs_2);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return { chunks: chunks, selection: selection };
    };
    EmbedSchematicImplementation.prototype.build = function (selection, pick) {
        var e_3, _a;
        var _this = this;
        var attrs = Object.keys(this.embeds);
        var parentSelection = {
            root: selection.root,
            embed: __assign({}, selection.embed),
        };
        var embedSelections = {};
        try {
            for (var attrs_3 = __values(attrs), attrs_3_1 = attrs_3.next(); !attrs_3_1.done; attrs_3_1 = attrs_3.next()) {
                var attr = attrs_3_1.value;
                embedSelections[attr] = selection.embed[attr];
                delete parentSelection.embed[attr];
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (attrs_3_1 && !attrs_3_1.done && (_a = attrs_3.return)) _a.call(attrs_3);
            }
            finally { if (e_3) throw e_3.error; }
        }
        var result = this.parent(this.vars).build(parentSelection, pick);
        var unprimedResult = {
            pending: true,
            primed: false,
        };
        if (!result.primed) {
            return unprimedResult;
        }
        var invalidated = result.invalidated;
        var pending = result.pending;
        if (result.hasRejection) {
            return {
                hasRejection: true,
                invalidated: invalidated,
                pending: pending,
                primed: true,
                rejection: result.rejection,
            };
        }
        if (!result.hasData) {
            return {
                hasData: false,
                hasRejection: false,
                invalidated: false,
                pending: false,
                primed: true,
            };
        }
        var data = __assign({}, result.data);
        var embeddedResults = attrs.map(function (attr) {
            return _this.embeds[attr](_this.vars, result.data).build(embedSelections[attr], pick);
        });
        for (var i = 0; i < attrs.length; i++) {
            var attr = attrs[i];
            var embeddedResult = embeddedResults[i];
            if (embeddedResult) {
                if (!embeddedResult.primed) {
                    return unprimedResult;
                }
                else if (embeddedResult.hasRejection) {
                    return {
                        hasRejection: true,
                        invalidated: invalidated,
                        pending: pending,
                        primed: true,
                        rejection: embeddedResult.rejection,
                    };
                }
                else if (!embeddedResult.hasData) {
                    return {
                        hasData: false,
                        hasRejection: false,
                        invalidated: false,
                        pending: false,
                        primed: true,
                    };
                }
                data[attr] = embeddedResult.data;
                invalidated = invalidated || embeddedResult.invalidated;
                pending = pending || embeddedResult.pending;
            }
        }
        return {
            hasData: true,
            invalidated: invalidated,
            pending: pending,
            primed: true,
            data: data,
        };
    };
    return EmbedSchematicImplementation;
}());
//# sourceMappingURL=embedSchematic.js.map